<template>
	<svg t="1686291859253" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2640"
		xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200">
		<path
			d="M87.54 92.43v790.2H312.9V92.43H87.54z m315.82 0v790.2h225.36V92.43H403.36z m319.37 0v790.2h225.35V92.43H722.73z"
			p-id="2641"></path>
	</svg>
</template>
